import { type ReactNode } from 'react';
import { BotaoIndicar } from './BotaoIndicar';

export { Esqueleto, FalhaRede, BlocoAviso } from './ui';

/**
 * Estado vazio de "ainda não indicou ninguém" (UX §5.5 / §6.6). Também cobre o
 * caso "só rejeitadas" — do ponto de vista do cliente, ainda não aconteceu.
 * Convida a indicar com o CTA real.
 */
export function EstadoVazioIndicar({
  codigo,
  brindeIndicado,
  titulo = 'Você ainda não indicou ninguém. Que tal começar agora?',
}: {
  codigo: string;
  brindeIndicado: string | null;
  titulo?: string;
}): ReactNode {
  return (
    <div className="flex flex-col gap-4 rounded-2 bg-superficie p-5">
      <p className="tipo-corpo text-tinta">{titulo}</p>
      <BotaoIndicar codigo={codigo} brindeIndicado={brindeIndicado} />
    </div>
  );
}
